(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function dakidenHomeRescue() {
  if (window.__dakidenHomeRescueReady) return;

  window.__dakidenHomeRescueReady = true;

  const removeRetiredHeader = () => {
    document
      .querySelectorAll('#dkd-global-header, #header-group, .shopify-section-group-header-group')
      .forEach((element) => element.remove());

    if (document.body) {
      document.body.style.setProperty('--header-height', '0px');
      document.body.style.setProperty('--header-group-height', '0px');
      document.body.style.setProperty('--top-row-height', '0px');
    }

    document.querySelectorAll('#dkd-global-sidebar a').forEach((link) => {
      if (link.textContent.trim().toUpperCase() === 'WOLF') {
        link.setAttribute('href', '/collections/wolf-pillow-covers');
      }
    });
  };

  removeRetiredHeader();
  document.addEventListener('DOMContentLoaded', removeRetiredHeader);
  requestAnimationFrame(removeRetiredHeader);
  setTimeout(removeRetiredHeader, 250);
  setTimeout(removeRetiredHeader, 1000);

  new MutationObserver(removeRetiredHeader).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  const imageUrls = [
    'https://dakiden.com/cdn/shop/t/1/assets/dkd-effect-1.jpg',
    'https://dakiden.com/cdn/shop/t/1/assets/dkd-effect-2.jpg',
    'https://dakiden.com/cdn/shop/t/1/assets/dkd-effect-3.jpg',
    'https://dakiden.com/cdn/shop/t/1/assets/dkd-effect-4.jpg',
  ];

  const shouldRescue = () => {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    const hasNewWidgets = document.getElementById('dkd-global-sidebar');
    const hasOldHome = document.getElementById('dkd-sidebar') || document.getElementById('dkd-overlay');

    return path === '/' && !hasNewWidgets && hasOldHome;
  };

  const renderRescue = () => {
    if (!shouldRescue()) return;

    if (!new URLSearchParams(window.location.search).has('view')) {
      window.location.replace('/?view=picks2');
      return;
    }

    const oldHeader = document.getElementById('header-group');
    if (oldHeader) oldHeader.remove();

    document
      .querySelectorAll('#dkd-global-header, [id$="__sidebar_nav_custom"], [id$="__welcome_popup"], [id$="__hero_banner_dakiden"]')
      .forEach((element) => element.remove());

    if (!document.getElementById('dkd-rescue-style')) {
      const style = document.createElement('style');
      style.id = 'dkd-rescue-style';
      style.textContent = `
        body {
          --header-height: 0px;
          --header-group-height: 0px;
          --top-row-height: 0px;
          background: #ffffff;
        }

        #header-group,
        .shopify-section-group-header-group,
        [id$="__sidebar_nav_custom"],
        [id$="__welcome_popup"],
        [id$="__hero_banner_dakiden"],
        #dkd-global-header,
        #dkd-sidebar,
        #dkd-overlay,
        #dkd-bed-widget {
          display: none !important;
        }

        #dkd-global-sidebar,
        #dkd-right-window,
        #dkd-custom-panel,
        #dkd-home {
          font-family: inherit;
          box-sizing: border-box;
        }

        #dkd-global-sidebar {
          position: fixed;
          left: 24px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10000;
          display: flex;
          align-items: center;
          padding: 10px;
          background: rgba(255, 255, 255, 0.96);
          backdrop-filter: blur(14px);
          border: 1px solid rgba(0, 143, 156, 0.2);
          border-radius: 999px;
          box-shadow: 0 16px 38px rgba(20, 33, 61, 0.14);
        }

        .dkd-global-sidebar-pages {
          display: flex;
          flex-direction: column;
        }

        .dkd-global-sidebar-link {
          color: #14213d;
          text-decoration: none;
          font-size: 15px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.04em;
          padding: 14px 28px;
          border-radius: 999px;
          white-space: nowrap;
          background: #f4fbff;
          border: 1px solid rgba(0, 143, 156, 0.18);
        }

        #dkd-right-window {
          position: fixed;
          right: 24px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10000;
          width: 228px;
          padding: 18px;
          border-radius: 18px;
          background: rgba(255, 255, 255, 0.97);
          border: 1px solid rgba(0, 143, 156, 0.24);
          box-shadow: 0 18px 44px rgba(20, 33, 61, 0.16);
          color: #14213d;
          text-align: left;
          backdrop-filter: blur(14px);
          cursor: pointer;
          appearance: none;
        }

        .dkd-window-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .dkd-window-icon {
          width: 48px;
          height: 44px;
          border-radius: 14px;
          display: grid;
          place-items: center;
          background: linear-gradient(135deg, #eaf9ff, #eefdf7);
          color: #008f9c;
          flex: 0 0 auto;
        }

        .dkd-window-title,
        .dkd-window-copy,
        .dkd-window-action {
          display: block;
        }

        .dkd-window-title {
          font-size: 15px;
          line-height: 1.12;
          font-weight: 900;
          letter-spacing: 0.06em;
        }

        .dkd-window-copy {
          margin-top: 3px;
          font-size: 13px;
          line-height: 1.35;
          color: #526579;
          font-weight: 750;
        }

        .dkd-window-action {
          margin-top: 12px;
          padding: 11px 12px;
          border-radius: 999px;
          background: #008f9c;
          color: #ffffff;
          text-align: center;
          font-size: 13px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.05em;
        }

        #dkd-custom-panel {
          position: fixed;
          right: 24px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10020;
          width: min(348px, calc(100vw - 32px));
          max-height: min(620px, calc(100vh - 48px));
          overflow: auto;
          padding: 20px;
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.98);
          border: 1px solid rgba(0, 143, 156, 0.24);
          box-shadow: 0 26px 70px rgba(20, 33, 61, 0.22);
          color: #14213d;
          backdrop-filter: blur(16px);
        }

        #dkd-custom-panel[hidden] {
          display: none;
        }

        .dkd-custom-panel-head {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 14px;
        }

        .dkd-custom-eyebrow {
          margin: 0 0 5px;
          color: #008f9c;
          font-size: 12px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        .dkd-custom-title {
          margin: 0;
          color: #14213d;
          font-size: 22px;
          line-height: 1.08;
          font-weight: 900;
          letter-spacing: 0;
        }

        .dkd-custom-close {
          width: 34px;
          height: 34px;
          flex: 0 0 auto;
          display: grid;
          place-items: center;
          border: 1px solid rgba(0, 143, 156, 0.18);
          border-radius: 50%;
          background: #f4fbff;
          color: #14213d;
          cursor: pointer;
        }

        .dkd-custom-copy {
          margin: 0 0 16px;
          color: #526579;
          font-size: 13px;
          line-height: 1.55;
          font-weight: 650;
        }

        .dkd-custom-list {
          display: grid;
          gap: 9px;
          margin: 0 0 17px;
          padding: 0;
          list-style: none;
        }

        .dkd-custom-list li {
          display: flex;
          align-items: flex-start;
          gap: 9px;
          padding: 10px 11px;
          border-radius: 14px;
          background: #f4fbff;
          color: #14213d;
          font-size: 13px;
          line-height: 1.35;
          font-weight: 750;
        }

        .dkd-custom-dot {
          width: 10px;
          height: 10px;
          margin-top: 4px;
          border-radius: 50%;
          background: #ffc83d;
          flex: 0 0 auto;
        }

        .dkd-custom-actions {
          display: grid;
          gap: 9px;
        }

        .dkd-custom-primary,
        .dkd-custom-secondary {
          display: block;
          padding: 12px 14px;
          border-radius: 999px;
          text-align: center;
          text-decoration: none;
          font-size: 13px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.05em;
        }

        .dkd-custom-primary {
          background: #008f9c;
          color: #ffffff;
        }

        .dkd-custom-secondary {
          background: #fff7d8;
          color: #14213d;
          border: 1px solid rgba(255, 200, 61, 0.42);
        }

        #dkd-home {
          min-height: calc(100svh - 40px);
          display: grid;
          place-items: center;
          padding: 64px clamp(122px, 13vw, 190px);
          background: #ffffff;
          color: #14213d;
        }

        .dkd-home-inner {
          width: min(100%, 980px);
          display: grid;
          grid-template-columns: minmax(0, 0.88fr) minmax(300px, 0.92fr);
          align-items: center;
          gap: clamp(28px, 5vw, 56px);
        }

        .dkd-home-kicker {
          margin: 0 0 12px;
          color: #008f9c;
          font-size: 13px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.14em;
          text-transform: uppercase;
        }

        #dkd-home h1 {
          margin: 0;
          max-width: 9em;
          color: #14213d;
          font-size: clamp(34px, 4.8vw, 58px);
          line-height: 0.98;
          font-weight: 900;
          letter-spacing: 0;
        }

        .dkd-home-lede {
          margin: 18px 0 0;
          max-width: 420px;
          color: #526579;
          font-size: clamp(15px, 1.55vw, 18px);
          line-height: 1.55;
          font-weight: 650;
        }

        .dkd-home-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 24px;
        }

        .dkd-home-primary,
        .dkd-home-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 44px;
          padding: 0 18px;
          border-radius: 999px;
          text-decoration: none;
          font-size: 13px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.05em;
        }

        .dkd-home-primary {
          background: #008f9c;
          color: #ffffff;
        }

        .dkd-home-secondary {
          background: #fff7d8;
          color: #14213d;
          border: 1px solid rgba(255, 200, 61, 0.46);
        }

        .dkd-home-gallery {
          width: min(100%, 420px);
          justify-self: center;
        }

        .dkd-home-stage {
          position: relative;
          width: 100%;
          aspect-ratio: 1;
          overflow: hidden;
          border-radius: 8px;
          background: #eefdf7;
          border: 1px solid rgba(0, 143, 156, 0.18);
          box-shadow: 0 22px 54px rgba(20, 33, 61, 0.14);
        }

        .dkd-home-slide {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.24s ease, visibility 0.24s ease;
        }

        .dkd-home-slide.is-active {
          opacity: 1;
          visibility: visible;
        }

        .dkd-home-controls {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin-top: 14px;
        }

        .dkd-home-control {
          width: 42px;
          height: 42px;
          display: grid;
          place-items: center;
          border: 1px solid rgba(0, 143, 156, 0.22);
          border-radius: 50%;
          background: #ffffff;
          color: #14213d;
          cursor: pointer;
          box-shadow: 0 10px 24px rgba(20, 33, 61, 0.1);
        }

        .dkd-home-count {
          min-width: 48px;
          color: #526579;
          text-align: center;
          font-size: 13px;
          line-height: 1;
          font-weight: 900;
        }

        @media (max-width: 989px) {
          #dkd-home {
            padding-inline: 108px;
          }

          .dkd-home-inner {
            grid-template-columns: 1fr;
            gap: 32px;
            text-align: center;
          }

          #dkd-home h1,
          .dkd-home-lede {
            margin-inline: auto;
          }

          .dkd-home-actions {
            justify-content: center;
          }
        }

        @media (max-width: 749px) {
          #dkd-global-sidebar {
            left: 10px;
            top: auto;
            bottom: 118px;
            transform: none;
            padding: 8px;
          }

          .dkd-global-sidebar-link {
            padding: 12px 22px;
            font-size: 12px;
          }

          #dkd-right-window {
            right: 10px;
            bottom: 18px;
            top: auto;
            transform: none;
            width: 184px;
            padding: 14px;
          }

          #dkd-custom-panel {
            right: 10px;
            left: 10px;
            top: auto;
            bottom: 18px;
            transform: none;
            width: auto;
            max-height: calc(100vh - 36px);
            padding: 18px;
          }

          #dkd-home {
            min-height: auto;
            padding: 42px 18px 230px;
          }

          .dkd-home-inner {
            grid-template-columns: 1fr;
            gap: 26px;
            text-align: center;
          }

          #dkd-home h1 {
            margin-inline: auto;
            font-size: 36px;
          }

          .dkd-home-lede {
            margin-inline: auto;
          }

          .dkd-home-actions {
            justify-content: center;
          }

          .dkd-home-gallery {
            width: min(100%, 330px);
          }
        }
      `;
      document.head.appendChild(style);
    }

    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) {
      main.innerHTML = `
        <section id="dkd-home" class="dkd-home">
          <div class="dkd-home-inner">
            <div class="dkd-home-copy">
              <p class="dkd-home-kicker">DakiDen Original</p>
              <h1>Furry Dakimakura Covers</h1>
              <p class="dkd-home-lede">Bright, soft, and character-led body pillow covers for furry and non-human designs.</p>
              <div class="dkd-home-actions">
                <a href="/?view=picks2" class="dkd-home-primary">BEST SELLERS</a>
                <a href="/pages/contact" class="dkd-home-secondary">CUSTOM ORDER</a>
              </div>
            </div>

            <div class="dkd-home-gallery" aria-label="Product effect images">
              <div class="dkd-home-stage">
                ${imageUrls
                  .map(
                    (url, index) =>
                      `<img class="dkd-home-slide${index === 0 ? ' is-active' : ''}" src="${url}" alt="Yukata wolf pillowcase effect image ${index + 1}" width="1200" height="1200" loading="${index === 0 ? 'eager' : 'lazy'}">`
                  )
                  .join('')}
              </div>
              <div class="dkd-home-controls" aria-label="Change product effect image">
                <button class="dkd-home-control" type="button" data-dkd-slide-prev aria-label="Previous image">&lt;</button>
                <span class="dkd-home-count" aria-live="polite">1 / 4</span>
                <button class="dkd-home-control" type="button" data-dkd-slide-next aria-label="Next image">&gt;</button>
              </div>
            </div>
          </div>
        </section>
      `;
    }

    document.body.insertAdjacentHTML(
      'beforeend',
      `
        <div id="dkd-global-sidebar" aria-label="Quick wolf navigation">
          <nav class="dkd-global-sidebar-pages" aria-label="Wolf page links">
            <a href="/collections/wolf-pillow-covers" class="dkd-global-sidebar-link">WOLF</a>
          </nav>
        </div>

        <button id="dkd-right-window" type="button" aria-label="Open custom order window" aria-expanded="false" aria-controls="dkd-custom-panel">
          <span class="dkd-window-top">
            <span class="dkd-window-icon" aria-hidden="true">
              <svg viewBox="0 0 64 52" width="32" height="29" focusable="false">
                <rect x="6" y="9" width="52" height="36" rx="8" fill="currentColor" opacity="0.18"/>
                <path d="M14 15h36c3 0 5 2 5 5v18c0 3-2 5-5 5H14c-3 0-5-2-5-5V20c0-3 2-5 5-5z" fill="currentColor" opacity="0.92"/>
                <path d="M14 21h36" stroke="#ffffff" stroke-width="3" stroke-linecap="round" opacity="0.85"/>
                <circle cx="18" cy="18" r="1.8" fill="#ffffff"/>
                <circle cx="24" cy="18" r="1.8" fill="#ffffff" opacity="0.72"/>
                <path d="M17 29h30M17 35h20" stroke="#ffffff" stroke-width="3" stroke-linecap="round" opacity="0.82"/>
              </svg>
            </span>
            <span>
              <span class="dkd-window-title">CUSTOM</span>
              <span class="dkd-window-copy">Body shape, role, size, material</span>
            </span>
          </span>
          <span class="dkd-window-action">OPEN</span>
        </button>

        <aside id="dkd-custom-panel" aria-label="Custom order details" hidden>
          <div class="dkd-custom-panel-head">
            <div>
              <p class="dkd-custom-eyebrow">Welcome</p>
              <h2 class="dkd-custom-title">Custom Daki Options</h2>
            </div>
            <button class="dkd-custom-close" type="button" aria-label="Close custom order window">x</button>
          </div>
          <p class="dkd-custom-copy">We accept custom body pillow cover ideas, from original roles to adjusted body shape, size, and fabric choice.</p>
          <ul class="dkd-custom-list">
            <li><span class="dkd-custom-dot" aria-hidden="true"></span><span>Character, role, outfit, pose, or story concept</span></li>
            <li><span class="dkd-custom-dot" aria-hidden="true"></span><span>Body shape and style direction adjustments</span></li>
            <li><span class="dkd-custom-dot" aria-hidden="true"></span><span>Custom size or material requests</span></li>
            <li><span class="dkd-custom-dot" aria-hidden="true"></span><span>One-of-a-kind furry and non-human designs</span></li>
          </ul>
          <div class="dkd-custom-actions">
            <a class="dkd-custom-primary" href="/pages/contact">CONTACT</a>
            <a class="dkd-custom-secondary" href="/?view=picks2">BEST SELLERS</a>
          </div>
        </aside>
      `
    );

    const trigger = document.getElementById('dkd-right-window');
    const panel = document.getElementById('dkd-custom-panel');
    const closeButton = panel?.querySelector('.dkd-custom-close');
    const slides = Array.from(document.querySelectorAll('.dkd-home-slide'));
    const count = document.querySelector('.dkd-home-count');
    const prev = document.querySelector('[data-dkd-slide-prev]');
    const next = document.querySelector('[data-dkd-slide-next]');
    let index = 0;

    const openPanel = () => {
      if (!panel || !trigger) return;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      closeButton?.focus({ preventScroll: true });
    };

    const closePanel = () => {
      if (!panel || !trigger) return;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    const renderSlide = () => {
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };

    trigger?.addEventListener('click', openPanel);
    closeButton?.addEventListener('click', closePanel);
    prev?.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      renderSlide();
    });
    next?.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      renderSlide();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel && !panel.hidden) closePanel();
    });

    document.addEventListener('click', (event) => {
      if (!panel || panel.hidden) return;
      if (panel.contains(event.target) || trigger?.contains(event.target)) return;
      closePanel();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRescue);
  } else {
    renderRescue();
  }
})();
